var _defs, _style, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 2048,
    height: 2048,
    id: "img1",
    href: "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgd2lkdGg9IjY0IiBoZWlnaHQ9IjY0Ij4KCTx0aXRsZT5wZXJzb24tMTg8L3RpdGxlPgoJPHN0eWxlPgoJCS5zMCB7IGZpbGw6ICNmZmZmZmYgfSAKCTwvc3R5bGU+Cgk8cGF0aCBjbGFzcz0iczAiIGQ9Im01NjUuMiA1MjEuOWM3Ni4yLTIzIDEzMi4xLTk3LjYgMTMyLjEtMTg2LjIgMC0xMDYuOS04MS4zLTE5My41LTE4MS42LTE5My41LTEwMC4zIDAtMTgxLjYgODYuNi0xODEuNiAxOTMuNSAwIDg3LjYgNTQuNiAxNjEuNiAxMjkuNSAxODUuNC0xNDIuMiAyMy4xLTI1MC44IDE0Ni41LTI1MC44IDI5NS4zIDAgMi45IDAgNS44IDAuMSA4LjcgMC45IDMxLjUgMjYuNSA1Ni43IDU4LjEgNTYuN2g0ODIuMWMzMS4yIDAgNTctMjQuNiA1OC01NS44IDAuMS0zLjIgMC4yLTYuNCAwLjItOS42LTAuMS0xNDcuMS0xMDYuMi0yNjkuNC0yNDYuMS0yOTQuNXoiLz4KPC9zdmc+"
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _use || (_use = /*#__PURE__*/React.createElement("use", {
    href: "#img1",
    transform: "matrix(.618,0,0,.618,-121.5,-122)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.3686bc9df7d156f8b1fa46631f1cd31a.svg";
export { ForwardRef as ReactComponent };